import { TableCell, TableRow, Stack, Collapse, Table } from '@mui/material';
import React, { useState } from 'react';
import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';

const SurveyBodyData = (props) =>
{
	const { question } = props;
	const [ expand, setExpand ] = useState(false);

	const handleExpand = () =>
	{
		setExpand(!expand);
	};

	const getType = {
		short          : 'Short Answer',
		singleChoice   : 'Single Choice',
		multipleChoice : 'Multiple Choice',
		star           : 'Star Rating'
	};

	return (
		<>
			<TableRow >
				<TableCell
					sx={{
						overflow     : 'hidden',
						textOverflow : 'ellipsis',
						whiteSpace   : 'nowrap',
						maxWidth     : '300px'
					}} className='firstLetter'
				>
					{question.question}
				</TableCell>
				<TableCell>
					{getType[question.questionType]}
				</TableCell>
				<TableCell >
					{[ 'singleChoice', 'multipleChoice' ].includes(question?.questionType) &&
					<Stack direction={'row'} onClick={handleExpand}>
						{expand
							? <IoMdArrowDropup cursor={'pointer'} fontSize='var(--pixel24)'/>
							:	<IoMdArrowDropdown cursor={'pointer'} fontSize='var(--pixel24)' />}
					</Stack>}
				</TableCell>
			</TableRow>
			{[ 'singleChoice', 'multipleChoice' ].includes(question?.questionType) && question?.options?.length > 0 && (
				<TableRow sx={{ '& > *': { borderBottom: 'none' }, background: 'var(--whiteLight)' }}>
					<TableCell style={{ padding: 0 }} colSpan={6}>
						<Collapse in={expand} timeout='auto' unmountOnExit>
							<Table aria-label='poll'>
								{question?.options.map((item, index) => (
									<TableRow key={`question-${item?._id ?? item}`}>
										<TableCell sx={{ minWidth: '150px' }}>{item}</TableCell>
									</TableRow>
								))}
							</Table>
						</Collapse>
					</TableCell>
				</TableRow>
			)}
		</>
	);
};

export default SurveyBodyData;
